import { routeConstant } from "shared/routes/routeConstant";
import { SUPPORTED_FORMATS } from "./enum";
import { store } from "shared/redux/store";
import { resetAuthReducer } from "shared/redux/reducers/authSlice";
import { toastMessage } from "shared/components/common/toast";

interface Dimensions {
  width: number;
  height: number;
}

function getWindowDimensions(): Dimensions {
  if (typeof window !== "undefined") {
    const { innerWidth: width, innerHeight: height } = window;
    return { width, height };
  }
  return { width: 0, height: 0 };
}

function isImage(filetype: string): boolean {
  return SUPPORTED_FORMATS.includes(filetype);
}

function findScreenTitle(pathname: string): string {
  const route = Object.values(routeConstant).find(
    (item) => item?.path === pathname
  );
  return route?.title || "";
}

const resetRedux = () => {
  const auth = store.getState()?.root?.auth;
  if (auth?.token) {
    store.dispatch(resetAuthReducer());
    toastMessage("error", "Session Expired");
    window.location.reload();
  }
};

function getTopPosition(divElement: HTMLElement): number {
  return (
    divElement.getBoundingClientRect().top - document.documentElement.clientTop
  );
}

function getLeftPosition(divElement: HTMLElement): number {
  return (
    divElement.getBoundingClientRect().left -
    document.documentElement.clientLeft
  );
}

function getDistanceBetweenDivs(div1: HTMLElement, div2: HTMLElement): number {
  const rect1 = div1.getBoundingClientRect();
  const rect2 = div2.getBoundingClientRect();
  const deltaX = Math.max(0, rect1.x - rect2.x) - (rect1.width + rect2.width);
  const deltaY = Math.max(0, rect1.y - rect2.y) - (rect1.height + rect2.height);

  return Math.sqrt(deltaX ** 2 + deltaY ** 2);
}

function getPercentageFromString(num: string): number {
  const parsedNum = parseFloat(num.replace("%", ""));
  return isNaN(parsedNum) ? 1 : parsedNum / 100 + 1;
}

function getNestedValue<T>(obj: Record<string, any>, key: string): T | null {
  return key.split(".").reduce((o, i) => (o ? o[i] : null), obj) as T | null;
}

function handleErrors(err: any) {
  if (typeof err?.response?.data.message === "object") {
    for (let i = 0; i < err?.response?.data.message.length; i++) {
      toastMessage("error", err?.response?.data.message[i]);
    }
  } else {
    toastMessage("error", err?.response?.data.message);
  }
}

export {
  getWindowDimensions,
  isImage,
  findScreenTitle,
  resetRedux,
  getTopPosition,
  getLeftPosition,
  getDistanceBetweenDivs,
  getPercentageFromString,
  getNestedValue,
  handleErrors,
};
